<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white flex-col gap-4 flex"
    >
        <div>
            <div class="font-bold text-xs text-slate-700 mb-2">Favorite</div>
            <vx-box color="info" class="p-4">
                <div class="flex flex-col gap-3">
                    <div
                        v-for="favoriteOption in favoriteOptions"
                        :key="favoriteOption.value"
                        class="flex gap-2 items-center text-sm cursor-pointer"
                        @click.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.space.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.enter.prevent="filters.is_favorite = favoriteOption.value"
                    >
                        <vx-radio :modelValue="filters.is_favorite === favoriteOption.value"></vx-radio>
                        {{ favoriteOption.label }}
                    </div>
                </div>
            </vx-box>
        </div>
    </div>
</template>

<script setup>
import { VxBox, VxRadio } from '@voxie/frontend-components';

const favoriteOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const filters = defineModel({
    default: () => ({}),
});
</script>
